export const getPO = `
  query GetPO($poid: String, $asn: String) {
    getPO(poid: $poid, asn: $asn)
  }
`;

export const postItem = `
  query PostItem($body: String) {
    postItem(body: $body)
  }
`;

export const printItem = `
  query PrintItem($body: String) {
    printItem(body: $body)
  }
`;

export const getQmFeatureFlags = `
  query GetQmFeatureFlags {
    getQmFeatureFlags {
      qmNewDashboardEnabled
      qmSiteInboundEnabled
    }
  }
`;

export const setQmFeatureFlags = `
  mutation SetQmFeatureFlags($input: SetQmFeatureFlagsInput!) {
    setQmFeatureFlags(input: $input) {
      qmNewDashboardEnabled
      qmSiteInboundEnabled
    }
  }
`;

export const onSetQmFeatureFlags = `
  subscription OnSetQmFeatureFlags {
    onSetQmFeatureFlags {
      qmNewDashboardEnabled
      qmSiteInboundEnabled
    }
  }
`;

const QM_RECORD_FIELDS = `
        qmId
        qmNumber
        type
        typeLabel
        status
        reasonCode
        reasonLabel
        closureCode
        closureLabel
        sscc
        asn
        poNumber
        poLine
        poLineId
        itemId
        supplierCode
        supplierName
        contactName
        itemLocation
        packageCount
        packageType
        otherInformation
        description
        closureNotes
        createdBy
        createdAt
        updatedBy
        updatedAt
        closedAt
        statusHistory {
          id
          fromStatus
          toStatus
          changedBy
          changedAt
          note
        }
        changeHistory {
          id
          fieldName
          oldValue
          newValue
          changedBy
          changedAt
        }
        comments {
          id
          body
          createdBy
          createdAt
        }
        poLines {
          lineIndex
          poLineId
          poLine
          itemId
          linePayload
          orderedQuantity
          receivedQuantity
          quantityVariance
        }
        packages {
          packageNumber
          packageType
        }
  `;

export const createQmRecord = `
  mutation CreateQmRecord($input: CreateQmRecordInput!) {
    createQmRecord(input: $input) {
      ${QM_RECORD_FIELDS}
    }
  }
`;

export const updateQmRecord = `
  mutation UpdateQmRecord($input: UpdateQmRecordInput!) {
    updateQmRecord(input: $input) {
      ${QM_RECORD_FIELDS}
    }
  }
`;

export const getQmRecord = `
  query GetQmRecord($qmId: Int, $qmNumber: String) {
    getQmRecord(qmId: $qmId, qmNumber: $qmNumber) {
      ${QM_RECORD_FIELDS}
    }
  }
`;

export const listQmReferenceReasons = `
  query ListQmReferenceReasons($typeCode: String) {
    listQmReferenceReasons(typeCode: $typeCode) {
      code
      label
      displayOrder
    }
  }
`;

export const listQmReferenceClosureCodes = `
  query ListQmReferenceClosureCodes($reasonCode: String) {
    listQmReferenceClosureCodes(reasonCode: $reasonCode) {
      code
      label
      reasonCode
      displayOrder
    }
  }
`;

export const listQmReferenceLocations = `
  query ListQmReferenceLocations {
    listQmReferenceLocations {
      code
      label
      displayOrder
    }
  }
`;

export const listQmReferenceLocationsAdmin = `
  query ListQmReferenceLocationsAdmin {
    listQmReferenceLocationsAdmin {
      code
      label
      displayOrder
      active
    }
  }
`;

export const createQmReferenceLocation = `
  mutation CreateQmReferenceLocation($input: CreateQmLocationInput!) {
    createQmReferenceLocation(input: $input) {
      code
      label
      displayOrder
      active
    }
  }
`;

export const updateQmReferenceLocation = `
  mutation UpdateQmReferenceLocation($input: UpdateQmLocationInput!) {
    updateQmReferenceLocation(input: $input) {
      code
      label
      displayOrder
      active
    }
  }
`;

export const archiveQmReferenceLocation = `
  mutation ArchiveQmReferenceLocation($input: ArchiveQmLocationInput!) {
    archiveQmReferenceLocation(input: $input) {
      code
      label
      displayOrder
      active
    }
  }
`;

export const listQmRecords = `
  query ListQmRecords($page: Int, $pageSize: Int, $filter: ListQmRecordsFilterInput) {
    listQmRecords(page: $page, pageSize: $pageSize, filter: $filter) {
      items {
        ${QM_RECORD_FIELDS}
      }
      totalCount
      page
      pageSize
    }
  }
`;

export const getQmDashboardSummary = `
  query GetQmDashboardSummary($filter: ListQmRecordsFilterInput) {
    getQmDashboardSummary(filter: $filter) {
      total
      created
      pending
      closed
    }
  }
`;

export const addQmComment = `
  mutation AddQmComment($input: AddQmCommentInput!) {
    addQmComment(input: $input) {
      ${QM_RECORD_FIELDS}
    }
  }
`;

const QM_ATTACHMENT_FIELDS = `
        id
        qmId
        fileName
        mimeType
        sizeBytes
        uploadedBy
        uploadedAt
        downloadUrl
  `;

export const getUploadUrl = `
  query GetUploadUrl($qmId: Int!, $fileName: String!, $mimeType: String) {
    getUploadUrl(qmId: $qmId, fileName: $fileName, mimeType: $mimeType) {
      uploadUrl
      s3Key
    }
  }
`;

export const listAttachments = `
  query ListAttachments($qmId: Int!) {
    listAttachments(qmId: $qmId) {
      ${QM_ATTACHMENT_FIELDS}
    }
  }
`;

export const confirmAttachment = `
  mutation ConfirmAttachment($input: ConfirmAttachmentInput!) {
    confirmAttachment(input: $input) {
      ${QM_ATTACHMENT_FIELDS}
    }
  }
`;

export const onCreateQmRecord = `
  subscription OnCreateQmRecord {
    onCreateQmRecord {
      ${QM_RECORD_FIELDS}
    }
  }
`;

export const onUpdateQmRecord = `
  subscription OnUpdateQmRecord {
    onUpdateQmRecord {
      ${QM_RECORD_FIELDS}
    }
  }
`;

export const onPublishQmLiveUpdate = `
  subscription OnPublishQmLiveUpdate {
    onPublishQmLiveUpdate {
      ${QM_RECORD_FIELDS}
    }
  }
`;

export const onAddQmComment = `
  subscription OnAddQmComment {
    onAddQmComment {
      ${QM_RECORD_FIELDS}
    }
  }
`;
